export const environment = {
  production: true,
  buildId: '2623177316918091',
  configFile: 'config.json',
};
